/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./ToolbarAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], function(_, ToolbarAPI, APIFactory) {
	class Toolbar {
		constructor({ dashboardAPI, content }){
			this._toolbarDock = dashboardAPI.getFeature('ToolbarDock');
			this._transactionApi = dashboardAPI.getFeature('Transaction');
			this._content = content;
			this.type = dashboardAPI.getType();
			this.dashboardAPI = dashboardAPI;
		}

		initialize() {
			const isExplore = this.type.toUpperCase()==='EXPLORE';
			if (!isExplore) {
				this._internalApi = APIFactory.createAPI(this, [ToolbarAPI]);
				this._registerEvents();
			}
		}

		getAPI(type){
			if(type === 'internal'){
				return this._internalApi;
			}
		}

		_registerEvents() {
			this._visEvents = {
				'change:visualization:slots:dataitems:addMapping': this._refreshHandler,
				'change:visualization:slots:dataitems:removeMapping': this._refreshHandler
			};
			for (let key in this._visEvents) {
				this._content.on(key, this._visEvents[key], this);
			}

		}

		_deregisterEvents () {
			for (let key in this._visEvents) {
				this._content.off(key, this._visEvents[key], this);
			}
		}

		destroy() {
			this._deregisterEvents();
			this._content = null;
		}

		_refreshHandler(options) {
			const transactionToken = options && options.transactionToken;
			return this._transactionApi.registerTransactionHandler(transactionToken || {}, this, function() {
				this.refresh();
			}.bind(this), options);
		}

		refresh(){
			const IDList = [this._content.getId()];
			if(_.isEqual(IDList, this._toolbarDock.getOwnerIDs())){
				const contentActions = this.dashboardAPI.getFeature('ContentActions');
				const actions = contentActions.getContentActionList(IDList);
				this._toolbarDock.updateODTState(actions, IDList);
			}
		}
	}
	return Toolbar;
});
